export default [
  { text: "Name", value: "name", order: 1, hidable: false, hidden: false },
  // { text: "Default", value: "isDefault", order: 3, hidable: false, hidden: false },
  {
    text: "System",
    value: "isSystem",
    order: 2,
    hidable: false,
    hidden: false,
  },
  {
    text: "Users",
    value: "users",
    order: 3,
    hidable: false,
    hidden: false,
    width: "240px",
  },
  {
    text: "Actions",
    value: "actions",
    align: "left",
    width: "64px",
    sortable: false,
    order: 4,
    hidable: true,
    hidden: false,
  },
];
